import { AuthUser } from '@app/core/types/users';
import { User as Auth0User } from '@auth0/auth0-react';
import { UserRole } from '@mi-front/core';
import { useIsImpersonationOn } from '../../impersonation/hooks/useIsImpersonationOn';
import { useAuthContext } from '../context/auth-context';
import { Client } from '@app/core/types/client';

interface UseAuthResult {
  user: AuthUser;
  auth0User: Auth0User;
  client: Client | null;
  isSuperadmin: boolean;
  isImpersonated: boolean;
}

export function useAuth(): UseAuthResult {
  const { auth, auth0User } = useAuthContext();
  const isImpersonated = useIsImpersonationOn();

  if (!auth) {
    throw new Error('No authentication found!');
  }

  return {
    ...auth,
    auth0User,
    isSuperadmin: auth.user.role === UserRole.SUPERADMIN,
    isImpersonated,
  };
}
